const getMetadata = ({ node, nodeMap, parentId, index }) => {
  const { isArchived = false } =
    // TODO: only use dataSetNodeWrapper once backend unifies everything
    node?.standardsWrapper?.properties ||
    node?.dataSetNodeWrapper?.properties ||
    node?.properties ||
    {};
  const parentUID = nodeMap.get(parentId)?.uid;

  return {
    isArchived,
    parentUID,
    rowNo: index + 1,
  };
};

export default getMetadata;
